import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { apiLogout_AC } from '../../store/actions/api';
var lastActiveStr = "__EXACTA_APP_LastActive";
export default function (props) {
    var _a = props.timeout, timeout = _a === void 0 ? 1000 * 60 * 15 : _a, _b = props.logoutOnTimeout, logoutOnTimeout = _b === void 0 ? true : _b, onIdle = props.onIdle;
    var dispatch = useDispatch();
    var handleOnIdle = function (event) {
        var lastActive = Number(localStorage.getItem(lastActiveStr));
        console.log('user is idle', Date.now() > lastActive + timeout, {
            lastActive: new Date(lastActive),
            lastActiveNum: lastActive,
            timeout: timeout,
            now: Date.now(),
            compare: lastActive + timeout,
        });
        console.log('last active', getLastActiveTime());
        if (Date.now() > lastActive + timeout - 5000) {
            if (logoutOnTimeout) {
                dispatch(apiLogout_AC());
            }
            if (onIdle) {
                onIdle();
            }
            return false;
        }
        return true;
    };
    var handleOnActive = function (event) {
        if (handleOnIdle) {
            localStorage.setItem(lastActiveStr, "" + +new Date());
        }
    };
    var getLastActiveTime = useIdleTimer({
        timeout: timeout,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnActive,
        debounce: 500,
    }).getLastActiveTime;
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=index.js.map